import {Injectable} from '@angular/core';
import {BaseEndpoint} from "../../base/endpoints/base.endpoint";
import {IParams} from "../../base/endpoints/iparams";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DashEndpoint extends BaseEndpoint {

  constructor() {
    super();
  }

  static CRUDEXAMPLES = {
    CRUDEXAMPLE_ENDPOINT: environment.base_url + '/api/v1/crudexamples',
    CRUDEXAMPLE_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/crudexamples',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static LABELS = {
    LABEL_ENDPOINT_POLLBOX: environment.base_url + '/api/v1/public/labels/POLLBOX/children',
    LABEL_ENDPOINT: environment.base_url + '/api/v1/labels',
    LABEL_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/labels',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    SEARCH_BY_PARENT(endpoint: string, params: IParams) {
      return endpoint.concat("/children").concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.LABEL_ENDPOINT
    },
    GET(id: number): string {
      return this.LABEL_ENDPOINT + '/' + id
    },
    GET_MULTIPLE(ids: number[]): string {
      return this.LABEL_ENDPOINT + '/multiple/by-ids?ids=' + ids.join(',')
    },
    UPDATE(id: number): string {
      return this.LABEL_ENDPOINT + '/' + id
    },
  }

  static FEEDBACKS = {
    FEEDBACK_ENDPOINT: environment.base_url + '/api/v2/feedbacks',
    FEEDBACK_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/feedbacks',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.FEEDBACK_ENDPOINT
    },
    GET(id: number): string {
      return this.FEEDBACK_ENDPOINT + '/' + id
    },
    UPDATE(id: number): string {
      return this.FEEDBACK_ENDPOINT + '/' + id
    },
    TAKE_ACTION(id: number): string {
      return this.FEEDBACK_ENDPOINT_ADMIN + '/' + id + '/action'
    }
  }

  static POPTIONS = {
    POPTION_ENDPOINT: environment.base_url + '/api/v1/poll-options',
    POPTION_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/poll-options',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.POPTION_ENDPOINT
    },
    GET(id: number): string {
      return this.POPTION_ENDPOINT + '/' + id
    },
    UPDATE(id: number): string {
      return this.POPTION_ENDPOINT + '/' + id
    },
  }

  static ACVALIDATIONTOKENS = {
    ACVALIDATIONTOKEN_ENDPOINT: environment.base_url + '/api/v1/validation-tokens',
    ACVALIDATIONTOKEN_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/validation-tokens',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.ACVALIDATIONTOKEN_ENDPOINT
    },
    GET(id: number): string {
      return this.ACVALIDATIONTOKEN_ENDPOINT + '/' + id
    },
    UPDATE(id: number): string {
      return this.ACVALIDATIONTOKEN_ENDPOINT + '/' + id
    },
  }

  static LOCATIONTYPES = {
    LOCATIONTYPE_ENDPOINT: environment.base_url + '/api/v1/location-types',
    LOCATIONTYPE_ENDPOINT_ADMIN: environment.base_url + '/api/v1/location-types',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.LOCATIONTYPE_ENDPOINT
    },
    GET(id: number): string {
      return this.LOCATIONTYPE_ENDPOINT + '/' + id
    },
    GET_MULTIPLE(ids: number[]): string {
      return this.LOCATIONTYPE_ENDPOINT + '/multiple/by-ids?ids=' + ids.join(',')
    },
    UPDATE(id: number): string {
      return this.LOCATIONTYPE_ENDPOINT + '/' + id
    },
  }

  static LOCATIONS = {
    LOCATION_ENDPOINT: environment.base_url + '/api/v1/public/locations',
    LOCATION_ENDPOINT_V2: environment.base_url + '/api/v2/locations',
    LOCATION_ENDPOINT_ADMIN: environment.base_url + '/api/v1/locations',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint + '/child-locations'
        .concat(BaseEndpoint.toParamString(params));
    },
    GET_LOCATIONS_FOR_TYPE(endpoint: string, id: number): string {
      return endpoint + '/' + id + '/locations'
    },
    CREATE(): string {
      return this.LOCATION_ENDPOINT
    },
    GET(id: number): string {
      return this.LOCATION_ENDPOINT + '/' + id
    },
    GET_MULTIPLE(ids: number[]): string {
      return this.LOCATION_ENDPOINT_V2 + '/multiple/by-ids?ids=' + ids.join(',')
    },
    UPDATE(id: number): string {
      return this.LOCATION_ENDPOINT + '/' + id
    },
  }

  static ADDRESSS = {
    ADDRESS_ENDPOINT: environment.base_url + '/api/v1/global-addresss',
    ADDRESS_ENDPOINT_V2: environment.base_url + '/api/v2/global-addresses',
    ADDRESS_ENDPOINT_ADMIN: environment.base_url + '/api/v1/global-addresss',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.ADDRESS_ENDPOINT
    },
    GET(id: number): string {
      return this.ADDRESS_ENDPOINT_V2 + '/' + id
    },
    UPDATE(id: number): string {
      return this.ADDRESS_ENDPOINT + '/' + id
    },
  }

  static ORGANIZATIONS = {
    ORGANIZATION_ENDPOINT: environment.base_url + '/api/v1/organizations',
    ORGANIZATION_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/organizations',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.ORGANIZATION_ENDPOINT_ADMIN
    },
    GET(endpoint: string, id: number): string {
      console.log(endpoint)
      return endpoint + '/' + id
    },
    GET_MY_ORGS(): string {
      return environment.base_url + '/api/v1/organizations/my-organizations/all'
    },
    GET_BY_ALIAS(alias: string): string {
      return environment.base_url + '/api/v1/organizations/by-alias/' + alias
    },
    UPDATE(id: number): string {
      return this.ORGANIZATION_ENDPOINT_ADMIN + '/' + id
    },
  }

  static TASKS = {
    TASK_ENDPOINT: environment.base_url + '/api/v2/tasks',
    TASK_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/tasks',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    CHANGE_STATE(endpoint: string, id: number, params: IParams): string {
      return endpoint + "/" + id + "/change-state" + BaseEndpoint.toParamString(params)
    },
    SEARCH_TASK_ACTIVITIES(taskId: number, params: IParams) {
      return this.TASK_ENDPOINT + "/" + taskId + "/activities" + BaseEndpoint.toParamString(params)
    }
  }

  static TASKSTATES = {
    TASKSTATE_ENDPOINT: environment.base_url + '/api/v2/task-states',
    TASKSTATE_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/task-states',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static BOARDS = {
    BOARD_ENDPOINT: environment.base_url + '/api/v2/boards',
    BOARD_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/boards',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static TASKASSIGNMENTS = {
    TASKASSIGNMENT_ENDPOINT: environment.base_url + '/api/v2/task-assignments',
    TASKASSIGNMENT_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/task-assignments',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    ASSIGN(taskId: number) {
      return DashEndpoint.TASKS.TASK_ENDPOINT + '/' + taskId + '/assignments'
    },
    REMOVE_ASSIGNMENT(taskId: number, assigneeId: string) {
      return DashEndpoint.TASKS.TASK_ENDPOINT + '/' + taskId + '/assignments/' + assigneeId
    }
  }
  static SEARCHHISTORIES = {
    SEARCHHISTORY_ENDPOINT: environment.base_url + '/api/v1/search-histories',
    SEARCHHISTORY_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/search-histories',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static BLOGS = {
    BLOG_ENDPOINT: environment.base_url + '/api/v1/websites',
    BLOG_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/websites',
    BLOG_ENDPOINT_PUBLIC: environment.base_url + '/api/v1/public/websites',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    GET_BY_SLUG_PUBLIC(slug: string): string {
      return this.BLOG_ENDPOINT_PUBLIC + "/slug/" + slug
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    PUBLISH(endpoint: string, id: number, params: IParams): string {
      return endpoint + '/' + id + "/publish".concat(BaseEndpoint.toParamString(params))
    },
    UPSERT_CONFIG(id: number): string {
      return this.BLOG_ENDPOINT + '/' + id + '/update-config'
    },
  }

  static POST_CATEGORIES = {
    POSTCATEGORY_ENDPOINT: environment.base_url + '/api/v1/article-categories',
    POSTCATEGORY_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/article-categories',
    POST_CATEGORY_ENDPOINT_PUBLIC(blogSlug: string) {
      return environment.base_url + '/api/v1/public/websites/' + blogSlug + "/categories"
    },
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static BLOGPOSTS = {
    BLOGPOST_ENDPOINT: environment.base_url + '/api/v1/articles',
    BLOGPOST_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/articles',
    BLOGPOST_ENDPOINT_PUBLIC: environment.base_url + '/api/v1/public/websites',
    BLOGPOST_ENDPOINT_PUBLIC_ALL(blogSlug: string) {
      return this.BLOGPOST_ENDPOINT_PUBLIC + '/' + blogSlug + "/articles"
    },
    BLOGPOST_BY_CATEGORY(blogSlug: string, categorySlug: string) {
      return environment.base_url + '/api/v1/public/websites/' + blogSlug + "/categories/" + categorySlug + "/articles"
    },
    BLOGPOST_BY_HASHTAG(blogSlug: string, hashtag: string) {
      return environment.base_url + '/api/v1/public/websites/' + blogSlug + "/hashtags/" + hashtag + "/articles"
    },
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    GET_TOP_HASHTAGS(blogSlug: string) {
      return this.BLOGPOST_ENDPOINT_PUBLIC.concat("/", blogSlug + "/top-hashtags")
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    GET_PUBLIC(endpoint: string, blogSlug: string, postSlug: string): string {
      return endpoint + '/' + blogSlug + "/articles/" + postSlug
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    PUBLISH(id: number, params: IParams): string {
      return this.BLOGPOST_ENDPOINT + '/' + id + "/publish".concat(BaseEndpoint.toParamString(params))
    },
  }

  static BLOGMENUS = {
    BLOGMENU_ENDPOINT: environment.base_url + '/api/v1/blog-menus',
    BLOGMENU_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/blog-menus',
    SEARCH_ENDPOINT_PUBLIC(blogSlug: string) {
      return environment.base_url + '/api/v1/public/websites/slug/' + blogSlug + "/menus"
    },
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static WEBPAGES = {
    WEBPAGE_ENDPOINT: environment.base_url + '/api/v1/webpages',
    WEBPAGE_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/webpages',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    PUBLISH(endpoint: string, id: number, published: boolean) {
      return endpoint + '/' + id + '/publish?published=' + published
    }
  }

  static QUESTIONNAIRES = {
    QUESTIONNAIRE_ENDPOINT: environment.base_url + '/api/v1/questionnaires',
    QUESTIONNAIRE_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/questionnaires',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static QUESTIONNAIREREVISIONS = {
    QUESTIONNAIREREVISION_ENDPOINT: environment.base_url + '/api/v2/questionnaire-revisions',
    QUESTIONNAIREREVISION_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/questionnaire-revisions',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    ACCEPT_REVISIONS(endpoint: string, ids: number[]): string {
      return endpoint + "/accept-revisions?ids=" + ids.join(",")
    },
    GENERATE_REVISIONS(endpoint: string, params: IParams): string {
      return endpoint + "/generate-with-ai" + BaseEndpoint.toParamString(params)
    }
  }

  static QUESTIONS = {
    QUESTION_ENDPOINT: environment.base_url + '/api/v2/questions',
    QUESTION_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/questions',
    REVISION_ENDPOINT: environment.base_url + '/api/v2/question-revisions',
    REVISION_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/question-revisions',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    IMPORT(questionnaireId: number) {
      return environment.base_url + "/api/v2/questionnaires/" + questionnaireId + "/import-questions"
    },

    SEARCH_REVISIONS(params: IParams) {
      return environment.base_url + "/api/v2/admin/question-revisions"
        + BaseEndpoint.toParamString(params)
    },
    REVISE_QUESTION(questionId: number) {
      return environment.base_url + "/api/v2/admin/question-revisions/questions/" + questionId + '/generate'
    },
    GENERATE_REVISIONS(params: IParams) {
      return environment.base_url + "/api/v2/admin/question-revisions/generate" + BaseEndpoint.toParamString(params)
    },
    CREATE_QUESTIONS_FROM_REVISIONS(revisionIds: number[]) {
      return environment.base_url + "/api/v2/admin/question-revisions/create-questions?revision_ids=" + revisionIds.join(',')
    },
    ACCEPT(revisionId: number) {
      return environment.base_url + "/api/v2/admin/question-revisions/" + revisionId + "/accept"
    },
    GET_REVISION(revisionId: number) {
      return environment.base_url + "/api/v2/admin/question-revisions/" + revisionId
    },
    UPDATE_REVISION(revisionId: number) {
      return environment.base_url + "/api/v2/admin/question-revisions/" + revisionId
    },
    DELETE_REVISION(revisionId: number) {
      return environment.base_url + "/api/v2/admin/question-revisions/" + revisionId
    },

  }

  static ANSWERS = {
    ANSWER_ENDPOINT: environment.base_url + '/api/v2/answers',
    ANSWER_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/answers',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(questionId: number): string {
      return environment.base_url + "/api/v2/questions/" + questionId + "/answers"
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(questionId: number, id: number): string {
      return environment.base_url + "/api/v2/questions/" + questionId + "/answers/" + id
    },
  }

  static ALLOWEDDOMAINS = {
    ALLOWEDDOMAIN_ENDPOINT: environment.base_url + '/api/v2/allowed-domains',
    ALLOWEDDOMAIN_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/allowed-domains',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    CHANGE_ACTIVATION(endpoint: string, id: number, activate: boolean): string {
      return endpoint + '/' + id + '/change-activation?activate=' + activate
    }
  }

  static POSTS = {
    POST_ENDPOINT: environment.base_url + '/api/v2/social/posts',
    POST_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/social/posts',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string, params: IParams): string {
      return endpoint.concat(BaseEndpoint.toParamString(params))
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number, params: IParams): string {
      return (endpoint + '/' + id).concat(BaseEndpoint.toParamString(params))
    },
  }

  static CLIENT_APPS = {
    CLIENT_APP_ENDPOINT: environment.base_url + '/api/v2/client-apps',
    CLIENT_APP_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/client-apps',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static BILLING_GATEWAYS = {
    GATEWAY_ENDPOINT: environment.billing_url + '/api/v1/gateways',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    TEST(endpoint: string, id: string): string {
      return endpoint + '/' + id + '/test'
    },
  }

  static BILLING_ROUTING_RULES = {
    ROUTING_RULE_ENDPOINT: environment.billing_url + '/api/v1/routing-rules',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
  }

  static BILLING_CUSTOMERS = {
    CUSTOMER_ENDPOINT: environment.billing_url + '/api/v1/customers',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
  }

  static BILLING_PAYMENT_METHODS = {
    LIST_FOR_CUSTOMER(params: IParams): string {
      return environment.billing_url + '/api/v1/payment-methods'.concat(BaseEndpoint.toParamString(params))
    },
    SET_DEFAULT(paymentMethodId: string): string {
      return environment.billing_url + '/api/v1/payment-methods/' + paymentMethodId + '/set-default'
    },
    DELETE(paymentMethodId: string): string {
      return environment.billing_url + '/api/v1/payment-methods/' + paymentMethodId
    },
  }

  static BILLING_TRANSACTIONS = {
    TRANSACTION_ENDPOINT: environment.billing_url + '/api/v1/payments',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    GET(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    REFUND(id: string): string {
      return environment.billing_url + '/api/v1/payments/' + id + '/refund'
    },
    CAPTURE(id: string): string {
      return environment.billing_url + '/api/v1/payments/' + id + '/capture'
    },
    SUMMARY(): string {
      return environment.billing_url + '/api/v1/payments/summary'
    },
  }

  static BILLING_API_KEYS = {
    API_KEY_ENDPOINT: environment.billing_url + '/api/v1/api-keys',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    REGENERATE(endpoint: string, id: number): string {
      return endpoint + '/' + id + '/regenerate'
    },
    DELETE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static BILLING_CONTENT_TEMPLATES = {
    CONTENT_TEMPLATE_ENDPOINT: environment.billing_url + '/api/v1/content-templates',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    DELETE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
  }

  static BILLING_PREPARED_CONTENTS = {
    PREPARED_CONTENT_ENDPOINT: environment.billing_url + '/api/v1/prepared-contents',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    DELETE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    FINALIZE(endpoint: string, id: string): string {
      return endpoint + '/' + id + '/finalize'
    },
    MARK_DRAFT(endpoint: string, id: string): string {
      return endpoint + '/' + id + '/draft'
    },
  }

  static BILLING_INVOICES = {
    INVOICE_ENDPOINT: environment.billing_url + '/api/v1/invoices',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: string): string {
      return endpoint + '/' + id
    },
    CANCEL(id: string): string {
      return environment.billing_url + '/api/v1/invoices/' + id + '/cancel'
    },
    VOID(id: string): string {
      return environment.billing_url + '/api/v1/invoices/' + id + '/void'
    },
    FINALIZE(id: string): string {
      return environment.billing_url + '/api/v1/invoices/' + id + '/finalize'
    },
  }

  static BILLING_INVOICES_EXTERNAL = {
    CREATE(): string {
      return environment.billing_url + '/api/v1/invoices/external'
    },
  }

  static BILLING_CHECKOUT = {
    CREATE(): string {
      return environment.billing_url + '/api/v1/checkout'
    },
    VERIFY(sessionId: string, txId: string): string {
      return `${environment.billing_url}/api/v1/checkout/verify?session_id=${sessionId}&tx=${txId}`
    },
  }

  static BILLING_DOCS = {
    CHECKOUT_DOCS: environment.billing_url + '/docs/checkout.html',
  }

  static BADGES = {
    BADGE_ENDPOINT: environment.base_url + '/api/v1/badges',
    BADGE_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/badges',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }
}
